import { DataTable } from './DataTable'
import { Button, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseModel } from '../model'
import { PlusOutlined, ExportOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setEditVisible, setMode, getDriverList, selectedRowKeys, handleExport } = baseModel()
    
    const handleBatchExport = async () => {
        if (selectedRowKeys.length === 0) {
            message.warning('请至少选择一条数据进行导出')
            return
        }
        
        const ids = selectedRowKeys.map(item => item.id) as string[]
        handleExport(ids)
    }
    
    const action = (
        <>
            <Button
                shape="round"
                type="primary"
                onClick={async () => {
                    await getDriverList()
                    setMode('add')
                    setEditVisible({ visible: true, value: {} })
                }}
            >
                <PlusOutlined />
                添加
            </Button>
            <Button
                shape="round"
                type="primary"
                onClick={handleBatchExport}
                style={{ marginLeft: '10px' }}
            >
                <ExportOutlined />
                批量导出
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}